@if (metadata$ | async; as metadata) {
@if (dashboardData$ | async; as dashboardData) {
<div class="container-fluid dashboard-container wave-background" id="printSection">
  <div class="container-fluid px-xl-5 px-2 pt-5" [ngClass]="{
                'huge-bottom-margin': dashboardData.inputValue.length == 0,
                'mb-5': dashboardData.inputValue.length == 1,
                'mb-md-0 mb-lg-5': dashboardData.inputValue.length == 2,
                'mb-xxl-5 mb-0': dashboardData.inputValue.length == 3,
                'mb-0': dashboardData.inputValue.length > 3
            }">
    <div class="row mb-2 position-relative">
      <div class="col d-flex align-items-center">
        <div class="col d-flex align-items-center">
          <h2 class="text-white d-inline-block">
            {{ metadata?.templateDriveName }}
          </h2>
          <button no-print ngbTooltip="Modifica" type="button" class="edit-button" (click)="openEditModal(metadata)">
            <i class="fas fa-pencil" aria-hidden="true"></i>
          </button>
        </div>
        <div class="d-flex align-items-end justify-content-space-between" no-print>
          @if (metadata?.quoteId) {
          <a *appHasRole="['admin','portfolio']" [href]="'https://docs.google.com/spreadsheets/d/' + metadata?.quoteId"
            target="_blank">
            <button ngbTooltip="Apri Spreadsheet" type="button" class="btn">
              <i class="fas fa-file text-white" aria-hidden="true"></i>
            </button>
          </a>
          }
          @if (metadata?.quoteId) {
          <button ngbTooltip="Copia url preventivo" type="button" class="ms-auto btn" (click)="copyQuoteUrl(metadata)">
            <i class="fas fa-copy text-white" aria-hidden="true"></i>
          </button>
          }
          @if (metadata?.processedDocumentId || !metadata?.templateDocumentId) {
          <button ngbTooltip="Download" type="button" class="ms-auto btn" (click)="print(metadata)">
            <i class="fas fa-download text-white" aria-hidden="true"></i>
          </button>
          }
          @if (metadata?.templateDocumentId && !metadata?.processedDocumentId) {
          <button ngbTooltip="Creating download template" type="button" class="ms-auto btn">
            <i class="fas fa-spinner fa-spin text-white" aria-hidden="true"> </i>
          </button>
          }
        </div>
      </div>
    </div>
    <div class="row">
      @for (input of dashboardData.inputValue | arrayReverseFilter : { type: 'text' }; track input) {
      <div class="py-2 d-flex col-xxl-4 col-lg-6">
        <div class="data-tile">
          <p class="data-tile-label" [innerHTML]="input.label | safeHtml"></p>
          <p class="data-tile-detail" [ngClass]="{ ' justify-content-end': false }">
            @if (!input.value) {
            -
            }
            @if (input.value) {
            @if (input.type !== 'checkbox_group') {
            {{ input.value | formatter : input.type }}
            } @else {
            @if (input.value?.split(','); as splittedValue) {
          <ul>
            @for (singleValue of splittedValue; track singleValue) {
            <li class="fs-6">
              {{ singleValue }}
            </li>
            }
          </ul>
          }
          }
          }
          </p>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="container-fluid pt-5 px-2 px-xl-5">
    <div class="row mb-4">
      <div class="col">
        <h2 class="dashboard-header">Risultati</h2>
      </div>
    </div>
    <div class="row mb-4">
      @for (section of dashboardData.outputValue.sections; track section) {
      @if (maxLength(dashboardData.outputValue.outputs[section]); as maxLength) {
      <div [ngClass]="maxLength > 100 ? 'col-12' : 'col-xxl-4 col-lg-6'" class="mb-4">
        <div class="dashboard-tile">
          <p class="dashboard-tile-title mb-3">
            {{ section }}
          </p>
          <div>
            @for (item of dashboardData.outputValue.outputs[section]; track item) {
            <div class="row">
              <div [ngClass]="maxLength > 100 ? 'col-4' : 'col-6'" [innerHTML]="item.label | safeHtml">
                {{ item.label }}
              </div>
              <div [ngClass]="maxLength > 100 ? 'col-8' : 'col-6 text-end'" class="text-break"
                [innerHTML]="item.value | appReplacePlaceholderWithUrl : metadata | safeHtml"></div>
            </div>
            }
          </div>
        </div>
      </div>
      }
      }
    </div>
    <div class="row mb-2 justify-content-between">
      <div class="col-auto">Data creazione: {{ metadata?.created | date }}</div>
      <div class="col-auto">
        Data validità:
        {{ sumDays(metadata?.created, metadata?.validityDays) | date }}
      </div>
    </div>
  </div>
</div>
} @else {
<app-loading [fullScreen]="true" [show]="true"></app-loading>
}
}
<app-loading [fullScreen]="true" [show]="showLoading"></app-loading>